/* eslint-disable jira/filename-case */
import { getLocalUrl } from '@jira/get-local-url/src/get-local-url.tsx';
import getPillarLocalDevelopment from '@jira/ssr__global-build-context/src/getPillarLocalDevelopment.tsx';

export function getReroutableURL(pathOrURL: string): string {
	// For local development environment only, otherwise removed during the bundling process
	if (__SERVER__ ? getPillarLocalDevelopment() : process.env.PILLAR_LOCAL_DEVELOPMENT === 'true') {
		try {
			const localUrl = new URL(getLocalUrl());
			const u = new URL(pathOrURL, localUrl.href);
			u.host = localUrl.host;
			u.protocol = localUrl.protocol;
			return u.href;
		} catch (e) {
			// When the URL constructor has `base` set, and `pathOrUrl` is always a string,
			// no string can trigger this catch block.
			// Just in case, log the error to help with debugging.
			// oxlint-disable-next-line no-console
			console.error('Failed to parse URL: ', pathOrURL, e);
		}
	}

	return pathOrURL;
}
